import { render, staticRenderFns } from "./choose-status.vue?vue&type=template&id=661df9b5&"
import script from "./choose-status.vue?vue&type=script&lang=js&"
export * from "./choose-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports